
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { 
    SolanaPartnerIcon, 
    SuiPartnerIcon, 
    CetusPartnerIcon, 
    JupiterPartnerIcon,
    PythPartnerIcon,
    PhantomPartnerIcon,
    HeliusPartnerIcon,
    BirdeyePartnerIcon,
    LayerZeroPartnerIcon
} from '../ui/PartnerIcons';
import { motion } from 'framer-motion';

const partners = [
    { name: 'Solana', Icon: SolanaPartnerIcon, scale: 1.0 },
    { name: 'Sui', Icon: SuiPartnerIcon, scale: 0.9 }, // Sui circle feels larger than Solana, scale down for balance
    { name: 'LayerZero', Icon: LayerZeroPartnerIcon, scale: 0.95 },
    { name: 'Jupiter', Icon: JupiterPartnerIcon, scale: 1.0 },
    { name: 'Pyth', Icon: PythPartnerIcon, scale: 1.0 },
    { name: 'Birdeye', Icon: BirdeyePartnerIcon, scale: 0.95 },
    { name: 'Cetus', Icon: CetusPartnerIcon, scale: 1.0 },
    { name: 'Phantom', Icon: PhantomPartnerIcon, scale: 1.0 },
    { name: 'Helius', Icon: HeliusPartnerIcon, scale: 0.95 },
];

export const Integrations: React.FC = () => {
    return (
        <section className="bg-white dark:bg-[#0A0B0F] py-24 border-y border-stone-100 dark:border-white/5 relative overflow-hidden">
            {/* Subtle background glow for the partner strip */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-32 bg-nobel-gold/5 blur-[100px] pointer-events-none"></div>

            <div className="container mx-auto px-6 relative z-10">
                <div className="text-center">
                    <h2 className="text-[10px] font-bold uppercase tracking-[0.4em] text-stone-400 dark:text-stone-500 mb-16">
                        THE GHOST ECOSYSTEM IS POWERED BY INDUSTRY LEADERS
                    </h2>
                    
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:flex lg:flex-wrap lg:justify-center items-center gap-x-8 gap-y-12 md:gap-x-20">
                        {partners.map((partner) => (
                           <motion.div 
                                key={partner.name} 
                                whileHover={{ y: -5 }}
                                className="group flex flex-col items-center gap-4 transition-all duration-500"
                            >
                                <div className="relative flex items-center justify-center">
                                    {/* Ghostly halo on hover */}
                                    <div className="absolute -inset-6 bg-stone-100 dark:bg-white/5 rounded-full scale-0 group-hover:scale-100 transition-transform duration-500 opacity-0 group-hover:opacity-100"></div>
                                    
                                    {/* @google/genai-fix: Wrap partner icon in a div to apply scaling style, as the icon components do not support a style prop. */}
                                    <div 
                                        className="relative z-10" 
                                        style={{ transform: `scale(${partner.scale})` }}
                                    >
                                        <partner.Icon 
                                            className="h-7 md:h-10 w-auto grayscale group-hover:grayscale-0 transition-all duration-500 opacity-40 group-hover:opacity-100 group-hover:drop-shadow-[0_0_8px_rgba(197,160,89,0.3)]" 
                                        />
                                    </div>
                                </div>
                                <span className="text-[9px] font-bold text-stone-400 dark:text-stone-600 group-hover:text-nobel-gold transition-colors duration-500 uppercase tracking-[0.25em] font-sans">
                                    {partner.name}
                                </span>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
